import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { SavedUrlService } from '../../core/services/saved-url.service';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';

@Injectable({
  providedIn: 'root',
})
export class NotAuthenticatedGuard implements CanActivate {
  constructor(
    private auth: AuthStoreService,
    private router: Router,
    private savedUrl: SavedUrlService,
  ) {
  }


  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    return !this.auth.isAuthenticated || this.getUrlTree();
  }

  private getUrlTree(): UrlTree {
    return this.router.parseUrl(this.savedUrl.url || '/dashboard');
  }
}
